import React from "react";

export const HARDWARE_CHOICES = [
  { value: "none", label: "No hardware" },
  { value: "new", label: "Order new hardware" },
  { value: "existing", label: "Use an existing computer" },
];

/**
 * The first hardware question of the SCO form (PBI #302): the answer decides which of the
 * hardware sections is shown, and "none" sends no hardware fields at all.
 */
const HardwareChoice = ({ value, onChange, disabled = false }) => (
  <div className="flex flex-col">
    <label className="block text-sm font-bold mb-2">Hardware</label>
    <div className="flex flex-col gap-1">
      {HARDWARE_CHOICES.map((choice) => (
        <label
          key={choice.value}
          className={`flex items-center gap-2 py-1 px-3 rounded ${disabled ? "text-mute-400" : "hover:bg-blue-50 cursor-pointer"}`}
        >
          <input
            type="radio"
            name="hardwareChoice"
            value={choice.value}
            checked={value === choice.value}
            onChange={() => onChange(choice.value)}
            disabled={disabled}
          />
          <span>{choice.label}</span>
        </label>
      ))}
    </div>
  </div>
);

export default HardwareChoice;
